import api from "@/utils/api.util";

export class AuthService {
  static RESOURCE = "/auth/";

  static me() {
    return api.get(this.RESOURCE + "me");
  }
}
